import { MessageSigningProtocols } from 'sats-connect';

import type { BitcoinSignProtocol } from '../../BitcoinWalletProvider.types';

export const getSatsConnectSigningProtocol = (
  protocol: BitcoinSignProtocol | undefined
): MessageSigningProtocols | undefined => {
  if (!protocol) {
    return undefined;
  }

  return protocol === 'ecdsa'
    ? MessageSigningProtocols.ECDSA
    : MessageSigningProtocols.BIP322;
};
